
<div class="page-container">

 <div class="header">
    <h2>Feed Overrides – {{ destination | titlecase }}</h2>

  <div class="destination-row">
    <label>Destination:</label>
    <mat-form-field appearance="fill">
      <mat-select [(value)]="destination" (selectionChange)="onDestinationChange($event.value)">
        <mat-option *ngFor="let d of destinations" [value]="d.code">
          {{ d.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

     <p class="subtitle">Manage override metadata for product #{{ productId }}</p>

    <div class="product-info" *ngIf="product">
      <div class="info-row">
        <div class="info-item">
          <label>Name</label>
          <span>{{ product.name }}</span>
        </div>

        <div class="info-item">
          <label>Product ID</label>
          <span>{{ product.product_id }}</span>
        </div>

        <div class="info-item description">
          <label>Description</label>
          <span>{{ product.description }}</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!form && loading" class="loading-container">
  <mat-spinner diameter="48"></mat-spinner>
</div>

  <form *ngIf="form && !loading" [formGroup]="form" class="form-layout">

    <div class="form-grid">
      <ng-container *ngFor="let field of fieldConfig">

        <mat-form-field appearance="outline" 
                        [class.full]="field.fullWidth">
          <mat-label>
            {{ field.label }}
            <span *ngIf="field.required" class="required"></span>
          </mat-label>

          <textarea *ngIf="field.controlType === 'textarea'"
                    matInput
                    [rows]="field.rows || 3"
                    [formControlName]="field.key">
          </textarea>

          <input *ngIf="field.controlType === 'text' || field.controlType === 'url'"
                 matInput
                 [formControlName]="field.key"/>
        </mat-form-field>

      </ng-container>
    </div>

    <div class="toggle-row">
      <mat-slide-toggle formControlName="is_excluded">
        Exclude this product from {{ destination | titlecase }} feed
      </mat-slide-toggle>
    </div>

    <div class="actions">
      <button mat-raised-button 
              color="primary"
              [disabled]="saving"
              (click)="save()">
        Save
      </button>

      <button mat-stroked-button 
              color="warn"
              routerLink="/admin/feeds">
        Cancel
      </button>
    </div>

  </form>

</div>
